<h2 mat-dialog-title class="meta-template-dialog-title">{{'contentTypes.metaTemplate' | translate}}</h2>
<mat-dialog-content class="meta-template-dialog-content">
  <section class="meta-template-intro">
    <div class="meta-template-intro-icon">M</div>
    <div>
      <strong>{{'contentTypes.metaTemplateIntroTitle' | translate}}</strong>
      <p>{{'contentTypes.metaTemplateIntroDescription' | translate}}</p>
    </div>
  </section>
  <app-schema-meta-form
    [metaTemplate]="metaTemplate"
    [showFieldValues]="false"
    (metaTemplateChange)="updateMetaTemplate($event)">
  </app-schema-meta-form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="meta-template-dialog-actions">
  <button mat-button (click)="dialogRef.close([false])">{{'cancel' | translate}}</button>
  <button mat-button class="orange-button" (click)="save()" [disabled]="!canSave">{{'save' | translate}}</button>
</mat-dialog-actions>
